import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const DELETED_USER = 'deleted_user'

interface Props {
  authorName: string
  createdAt: string | null | undefined
  authorAvatarUrl: string | null | undefined
}

const MetadataInfo = ({ authorName, createdAt, authorAvatarUrl }: Props) => {
  const deletedUser = authorName === DELETED_USER
  const name = deletedUser
    ? i18n.t('contract_versions.navigator.timeline.deleted_user')
    : authorName

  return (
    <Box flexDirection="row" alignItems="center" gap="s8" paddingLeft="s24">
      {!deletedUser && <Avatar size="s24" url={authorAvatarUrl} label={authorName} />}
      <Text size="100" color="grey800">
        {name} - {createdAt}
      </Text>
    </Box>
  )
}

export default MetadataInfo
